// extracted by mini-css-extract-plugin
export default {"card":"ClothingIcon_card__4VpKD","space":"ClothingIcon_space__gMGtJ","label":"ClothingIcon_label__He+JO"};